import { getVps } from '../modules/admin/actions'
import { batchPollMax } from '../constants'

// DataLoader-style coalescer for single-vp fetches. When many rows finish jobs in
// the same PollingManager cycle they each want to refresh their table row via getVp;
// firing one request per row bursts the rate limiter (429). loadVp collects all the
// vp fetches issued in the same tick and resolves them from a single batched getVps
// request. Each caller gets { data: vp } so it can be swapped in for getVp directly.
let queue = []
let scheduled = false

function flush() {
  scheduled = false
  const batch = queue
  queue = []

  const ids = [...new Set(batch.map(item => item.vpId))]
  const chunks = []
  for (let i = 0; i < ids.length; i += batchPollMax) {
    chunks.push(ids.slice(i, i + batchPollMax))
  }

  Promise.all(chunks.map(chunk => getVps(chunk)))
    .then(responses => {
      const data = Object.assign({}, ...responses.map(response => response.data))
      batch.forEach(item => item.resolve({ data: data[item.vpId] }))
    })
    .catch(error => {
      batch.forEach(item => item.reject(error))
    })
}

export function loadVp(vpId) {
  return new Promise((resolve, reject) => {
    queue.push({ vpId, resolve, reject })
    if (!scheduled) {
      scheduled = true
      // setTimeout(0) waits out the current tick so every getVp issued while a
      // batched progress response is processed lands in the same flush.
      setTimeout(flush, 0)
    }
  })
}
